export default __webpack_public_path__ + "static/media/register.2dd199e9.jpeg";